import { Link } from "react-router-dom";
import { OutboundLink } from "react-ga";
import React from "react";
import styles from "../styles/Footer.module.scss";

const Footer = () => (
  <div className={styles.container}>
    <div className={styles.containerInner}>
      <div className={styles.links}>
        <div>
          <h3>Links</h3>
          <ul>
            <li>
              <Link to="/top">Cards</Link>
            </li>
            <li>
              <Link to="/commanders">Commanders</Link>
            </li>
            <li>
              <Link to="/sets">Sets</Link>
            </li>
            <li>
              <Link to="/tribes">Tribes</Link>
            </li>
            <li>
              <Link to="/themes">Themes</Link>
            </li>
            <li>
              <Link to="/recs">Recs</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>About</h3>
          <ul>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://edhwiki.com/wiki/EDHREC"
                target="_blank"
                to="https://edhwiki.com/wiki/EDHREC"
              >
                FAQ
              </OutboundLink>
            </li>
            <li>
              <Link to="/bug-report">Report a Bug</Link>
            </li>
            <li>
              <Link to="/apply">Write for EDHREC</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>Data Sources</h3>
          <ul>
            <li>
              <OutboundLink
                eventLabel="https://aetherhub.com/"
                target="_blank"
                to="https://aetherhub.com/"
              >
                AetherHub
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://archidekt.com/"
                target="_blank"
                to="https://archidekt.com/"
              >
                Archidekt
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://commanderspellbook.com/"
                target="_blank"
                to="https://commanderspellbook.com/"
              >
                Commander Spellbook
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://deckstats.net/"
                target="_blank"
                to="https://deckstats.net/"
              >
                DeckStats
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://www.moxfield.com/"
                target="_blank"
                to="https://www.moxfield.com/"
              >
                Moxfield
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://www.mtggoldfish.com/"
                target="_blank"
                to="https://www.mtggoldfish.com/"
              >
                MTGGoldfish
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://scryfall.com/"
                target="_blank"
                to="https://scryfall.com/"
              >
                Scryfall
              </OutboundLink>
            </li>
          </ul>
        </div>
        <div>
          <h3>Follow Us</h3>
          <ul>
            <li>
              <OutboundLink
                eventLabel="https://www.facebook.com/edhrec1/"
                target="_blank"
                to="https://www.facebook.com/edhrec1/"
              >
                Facebook
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://www.instagram.com/edh_rec/"
                target="_blank"
                to="https://www.instagram.com/edh_rec/"
              >
                Instagram
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://www.linkedin.com/company/edhrec/"
                target="_blank"
                to="https://www.linkedin.com/company/edhrec/"
              >
                LinkedIn
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://twitter.com/edhrec"
                target="_blank"
                to="https://twitter.com/edhrec"
              >
                Twitter
              </OutboundLink>
            </li>
            <li>
              <OutboundLink
                eventLabel="https://articles.edhrec.com/feed/"
                target="_blank"
                to="https://articles.edhrec.com/feed/"
              >
                RSS Feed
              </OutboundLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
